import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ConfirmDialog = ({ open, title, content, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDialog-paper': {
          width: '600px', // Set your desired width
          maxWidth: 'none', // Prevent it from limiting the width to default sizes
          p: 2,
          borderRadius: '25px'
        }
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 2 }}>
        <CloseIcon onClick={onClose} fontSize="50px" sx={{ color: '#000', fontSize: '30px', cursor: 'pointer' }} />
      </Box>
      <DialogTitle
        sx={{
          fontWeight: 'bold',
          textAlign: 'center',
          color: '#130175'
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent
        sx={{
          fontWeight: '300',
          textAlign: 'center',
          color: '#130175'
        }}
      >
        {content}
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'center',
          gap: 2
        }}
      >
        <Button
          variant="contained"
          sx={{
            background: '#3F51B5d4',
            color: '#fff',
            textTransform: 'capitalize',
            '&:hover': {
              background: '#3F51B5d4'
            }
          }}
          onClick={onConfirm}
        >
          Proceed
        </Button>
        <Button
          variant="contained"
          sx={{
            background: '#3F51B5d4',
            color: '#fff',
            textTransform: 'capitalize',
            '&:hover': {
              background: '#3F51B5d4'
            }
          }}
          onClick={onClose}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
